<div *ngIf="entity" class="form-horizontal">
    <div class="col-md-7">
        <div class="form-group">
            <edit-prop isChild label="Creme Version" prop="comment" szs="2,3">
                <input class="form-control" type="text" [(ngModel)]="entity.cremeVersion">
            </edit-prop>
        </div>

        <div class="form-group">
            <edit-prop isChild label="Notes" prop="enabled" szs="2,5">
                <input class="form-control" type="text" [(ngModel)]="entity.description">
            </edit-prop>
        </div>
    </div>
</div>
